import { render, staticRenderFns } from "./Aia.vue?vue&type=template&id=136a119c&scoped=true"
import script from "./Aia.vue?vue&type=script&lang=js"
export * from "./Aia.vue?vue&type=script&lang=js"
import style0 from "./Aia.vue?vue&type=style&index=0&id=136a119c&prod&lang=scss"
import style1 from "./Aia.vue?vue&type=style&index=1&id=136a119c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a119c",
  null
  
)

export default component.exports